/* eslint-disable @typescript-eslint/init-declarations */
import {App} from 'antd';
import type {MessageInstance} from 'antd/es/message/interface';
import type {ModalStaticFunctions} from 'antd/es/modal/confirm';
import type {NotificationInstance} from 'antd/es/notification/interface';

let message: MessageInstance;
let Notification: NotificationInstance;
let Modal: Omit<ModalStaticFunctions, 'warn'>;

export default () => {
    const staticFunction = App.useApp();
    message = staticFunction.message;
    Modal = staticFunction.modal;
    Notification = staticFunction.notification;
    return null;
};

export {message, Notification, Modal};
